module.exports = __webpack_public_path__ + "img/car.c59b00df.png";